export const LOGIN_STEPS = {
  EMAIL: 'EMAIL',
  ACCOUNT_SELECTION: 'ACCOUNT_SELECTION',
  PASSWORD: 'PASSWORD',
  RESET_PASSWORD: 'RESET_PASSWORD',
  MFA: 'MFA',
};

const userDetails = [
  {
    key: 'first_name',
    label: 'First name',
    placeholder: 'Enter First name',
    type: 'text',
    section: 1,
    pattern: {
      value: /^[0-9a-zA-Z_-]*$/i,
      message: 'Special characters are not allowed.',
    },
  },

  {
    key: 'email',
    label: 'Email',
    placeholder: 'Enter email',
    type: 'text',
    section: 1,
    pattern: {
      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
      message: 'Invalid email address.',
    },
  },
  {
    key: 'last_name',
    label: 'Last name',
    placeholder: 'Enter Last name',
    type: 'text',
    section: 2,
    pattern: {
      value: /^[0-9a-zA-Z_-]*$/i,
      message: 'Special characters are not allowed.',
    },
  },
  {
    key: 'phone_number',
    label: 'Phone',
    placeholder: 'Enter Phone',
    type: 'text',
    section: 2,
  },
  {
    key: 'old_password',
    label: 'Current password',
    placeholder: 'Enter current password',
    type: 'password',
    section: 3,
  },
  {
    key: 'new_password',
    label: 'New password',
    placeholder: 'Enter new password',
    type: 'password',
    section: 4,
  },
];

export const onlyRequiredValidationRules = {
  required: {
    value: true,
    message: 'This field is required.',
  },
};

export const passwordValidationRules = {
  required: 'This field is required.',
  minLength: {
    value: 12,
    message: 'Password must have at least 12 characters.',
  },
  validate: (value) => {
    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasNumber = /[0-9]/.test(value);
    const hasSpecialChar = /[^a-zA-Z0-9]/.test(value);

    if (!hasUpperCase || !hasLowerCase || !hasNumber || !hasSpecialChar) {
      return 'Password should contain at least one uppercase letter, one lowercase letter, one number, and one special character.';
    }

    return true;
  },
};

export const validatePassword = (value) => {
  // 1. Check Required
  if (passwordValidationRules.required && !value) {
    return passwordValidationRules.required;
  }

  // 2. Check MinLength
  if (
    passwordValidationRules.minLength &&
    value.length < passwordValidationRules.minLength.value
  ) {
    return passwordValidationRules.minLength.message;
  }

  // 3. Check Custom 'validate' function
  if (passwordValidationRules.validate) {
    const result = passwordValidationRules.validate(value);
    // If result is a string, it's an error message. If true, it's valid.
    if (result !== true) {
      return result;
    }
  }

  return ''; // No error
};

export default userDetails;
